import { useEffect } from 'react';

import type { CarouselApi } from './Carousel';

/**
 * Registers a non-passive `touchmove` listener on `document` so Chrome's
 * compositor keeps touchmove events cancelable. When an embla carousel sits
 * under a CSS stacking context (e.g. a z-indexed `.content` in the V3 design),
 * the compositor misses embla's own non-passive listener and delivers
 * `cancelable: false`, which makes embla abort touch drags — finger swipe stops
 * working while mouse drag still does. The listener is tied to the carousel api
 * lifecycle so it only exists while a carousel is mounted.
 */
export const useEmblaTouchDragFix = (api: CarouselApi | undefined) => {
  useEffect(() => {
    if (!api) {
      return;
    }

    const noop = (() => undefined) as EventListener;
    document.addEventListener('touchmove', noop, { passive: false });

    return () => document.removeEventListener('touchmove', noop);
  }, [api]);
};
